document.addEventListener('DOMContentLoaded', function () {
    // Handle hash link if present on page load
    if (window.location.hash === '#mrupdater') {
        const toggle = document.getElementById('mrupdater');
        if (toggle) {
            // First collapse all collapsibles
            var allCollapsibles = document.querySelectorAll('.collapsible');
            allCollapsibles.forEach(function (collapsible) {
                var collapsibleButton = collapsible.querySelector('.collapsible__button');
                var collapsibleInnerContent = collapsible.querySelector('.collapsible__inner');
                collapsibleButton.setAttribute('aria-expanded', 'false');
                collapsibleInnerContent.style.height = '0px';
            });

            // Expand the targeted toggle
            toggle.setAttribute('aria-expanded', 'true');
            const inner = toggle.nextElementSibling;
            if (inner && inner.classList.contains('collapsible__inner')) {
                inner.style.height = inner.scrollHeight + 'px';
            }

            // Use the same smooth scroll behavior as click events
            setTimeout(() => {
                const buttonRect = toggle.getBoundingClientRect();
                const scrollTop = window.pageYOffset + buttonRect.top - 20;
                
                window.scrollTo({
                    top: scrollTop,
                    behavior: 'smooth'
                });
            }, 250);
        }
    }

    // Handle click events on collapsible buttons
    var collapsibleButtons = document.querySelectorAll('.collapsible__button');
    collapsibleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var parentcollapsible = this.closest('.collapsible');
            var innerContent = parentcollapsible.querySelector('.collapsible__inner');
            var wasExpanded = this.getAttribute('aria-expanded') === 'true';
            
            // First collapse all collapsibles
            var allCollapsibles = document.querySelectorAll('.collapsible');
            allCollapsibles.forEach(function (collapsible) {
                var collapsibleButton = collapsible.querySelector('.collapsible__button');
                var collapsibleInnerContent = collapsible.querySelector('.collapsible__inner');
                collapsibleButton.setAttribute('aria-expanded', 'false');
                collapsibleInnerContent.style.height = '0px';
            });

            // If the clicked accordion wasn't already expanded, expand it and scroll to it
            if (!wasExpanded) {
                this.setAttribute('aria-expanded', 'true');
                innerContent.style.height = innerContent.scrollHeight + 'px';
                
                setTimeout(() => {
                    const buttonRect = this.getBoundingClientRect();
                    const scrollTop = window.pageYOffset + buttonRect.top - 20;
                    
                    window.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth'
                    });
                }, 250);
            }
        });
    });
});